import { unwrapResult } from '@reduxjs/toolkit'
import { Col, Form, Radio, Input, Modal, ModalProps, Row, Select } from 'antd'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { stringTrim } from '../../../utils/StringUtils'
import {
  getAddEditType,
  getOrganizationName,
  isAddEditSupplierPartner,
  isShowSupplierPartner,
  getMachiningType,
} from '../../replaceMakeCenter/ReplaceMakeSupplierSclice'
import { getOrganizationPartnerName } from '../ReplaceMakeOrganizationSclice'
import {
  RecipeNormalDoseCategories, RecipeNormalDoseTypeName,
  RecipeNormalFrequencyCategories,
  RecipeNormalFrequencyName,
  RecipeNormalUsemethodCategories, RecipeNormalUsemethodName
} from "../../../models/decoctingSettingModal";

interface PartnerModalProps {
  bindId?: string
  partnerId?: string
  tenantId?: string
  organizationName?: string
  platformId?: string
  platformName?: string
  isAddPartnerModel?: boolean
}

export const AddPartnerModel = ({
  partnerId,
  organizationName,
  tenantId,
  platformId,
  platformName,
  bindId,
  onCancel,
  onOk,
  isAddPartnerModel,
  ...others
}: PartnerModalProps & ModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [isLoading, setIsLoading] = useState(false)

  const [selectMachiningType, setSelectMachiningType] = useState<any>()

  const options = [
    {
      value: 0,
      label: '患者地址',
    },
    {
      value: 1,
      label: '诊所自取',
    },
  ]

  const firstColumnLayout = {
    labelCol: { flex: '8rem' },
    wrapperCol: { flex: '25rem' },
  }

  const required = {
    rules: [
      {
        required: true,
      },
    ],
  }

  // 默认加工方式必须属于当前已选的加工方式，不属于时视为未选择
  const findMachiningTypeDefault = (value: any, options: any[]) => {
    if (value === undefined || value === null || value === '') {
      return undefined
    }
    const matched = options?.find(
      (v: any) => Number(v?.typeVal) === Number(value)
    )
    return matched ? matched.typeVal : undefined
  }
  // 机构名称
  const [tenantOptions, setTenantOptions] = useState([])
  // 代煎类别是否禁用
  const [decoctionTypeDisable, setDecoctionTypeDisable] = useState(true)
  // 加工方式是否禁用
  const [machiningTypeDisable, setMachiningTypeDisable] = useState(true)
  // 代煎类别
  const [category, setCategory] = useState<any>([])
  // 加工方式
  const [type, setType] = useState<any>([])

  // 饮片厂id
  const [supplierId, setSupplierId] = useState(0)

  useEffect(() => {
    console.log(selectMachiningType, 'selectMachiningType')
  }, [selectMachiningType])

  useEffect(() => {
    dispatch(
      getOrganizationPartnerName({ size: 10, current: 1, tenantIds: tenantId })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setTenantOptions(res)
      })
  }, [isAddPartnerModel])

  useEffect(() => {
    if (partnerId) {
      getCategory()
    } else {
      form.resetFields()
    }
  }, [partnerId])

  const getCategory = () => {
    dispatch(isShowSupplierPartner(bindId!))
      .then(unwrapResult)
      .then((res: any) => {
        const typeOptions: any = []
        setCategory(res.list)
        res.list?.forEach((el: any) => {
          el.outPotionDictList?.forEach((v: any) => {
            typeOptions.push(v)
          })
        })
        setType(typeOptions)
        setDecoctionTypeDisable(false)
        setMachiningTypeDisable(false)
        setSupplierId(res.supplierId)
        const machiningTypeSelect = res.machiningType
          .split(',')
          .map((el: string) => Number(el))
        const data = typeOptions.filter((v: any) =>
          machiningTypeSelect?.includes(v?.typeVal)
        )
        setSelectMachiningType(data)

        form.setFieldsValue({
          ...res,
          supplierId: res.supplierName,
          tenantId: res.tenantName,
          platformId: res.platformName,
          recipeNormalFrequency: res.recipeNormalFrequency || '每日一帖',
          recipeNormalUsemethod: res.recipeNormalUsemethod || '每帖两次',
          recipeNormalDose: res.recipeNormalDose || '每次200ml',
          decoctionType: res.decoctionType
            .split(',')
            .map((el: string) => Number(el)),
          machiningType: res.machiningType
            .split(',')
            .map((el: string) => Number(el)),
          receivingType: res.receivingType
            .split(',')
            .map((el: string) => Number(el)),
          machiningTypeDefault: findMachiningTypeDefault(
            res.machiningTypeDefault,
            data
          ),
        })
      })
  }

  return (
    <Modal
      {...others}
      title={partnerId ? '代煎设置' : '绑定代煎饮片厂'}
      width={700}
      confirmLoading={isLoading}
      cancelText='取消'
      okText='确定'
      maskClosable={false}
      onCancel={(e) => {
        if (!partnerId) {
          setDecoctionTypeDisable(true)
          setMachiningTypeDisable(true)
          form.resetFields()
          setCategory([])
          setType([])
        }
        onCancel && onCancel(e)
      }}
      onOk={(e) => {
        const selected: any[] = form.getFieldValue('machiningType') || []
        const matchedOptions = type?.filter((v: any) =>
          selected?.includes(v?.typeVal)
        )
        // 默认加工方式与当前加工方式不匹配时，清空后按未选择校验
        form.setFieldsValue({
          machiningTypeDefault: findMachiningTypeDefault(
            form.getFieldValue('machiningTypeDefault'),
            matchedOptions
          ),
        })
        form
          .validateFields()
          .then((values) => {
            const data = {
              ...values,
              tenantId,
              platformId,
              supplierId,
              decoctionType: values.decoctionType.join(','),
              machiningType: values.machiningType.join(','),
              receivingType: values.receivingType.join(','),
            }

            dispatch(isAddEditSupplierPartner(data))
              .then(unwrapResult)
              .then(() => {
                form.resetFields()
                onOk && onOk(e)
              })
          })
          .catch(() => {
            // Do nothing.
          })
      }}
    >
      <Form
        form={form}
        colon={false}
        autoComplete='off'
        initialValues={{
          tenantId: organizationName,
          platformId: platformName,
          signedType: 1,
          recipeNormalFrequency: '每日一帖',
          recipeNormalUsemethod: '每帖两次',
          recipeNormalDose: '每次200ml',
        }}
      >
        <Form.Item
          {...firstColumnLayout}
          label='代煎饮片厂名称'
          name='supplierId'
          {...required}
          rules={[{ required: true, message: '机构名称不能为空' }]}
        >
          <Select
            showSearch
            placeholder='请选择合作机构'
            defaultActiveFirstOption={false}
            showArrow={false}
            filterOption={false}
            disabled={partnerId ? true : false}
            onSelect={(id: number) => {
              setSupplierId(id)
              setDecoctionTypeDisable(false)
              dispatch(getAddEditType({ tenantId, id }))
                .then(unwrapResult)
                .then((res: any) => setCategory(res))
              setSelectMachiningType([])
              form.setFieldsValue({
                machiningType: [],
                decoctionType: [],
                machiningTypeDefault: undefined,
              })
            }}
            onSearch={(v: string) => {
              dispatch(
                getOrganizationPartnerName({
                  size: 10,
                  current: 1,
                  tenantIds: tenantId,
                  keyWord: v,
                })
              )
                .then(unwrapResult)
                .then((res: any) => {
                  setTenantOptions(res)
                })
            }}
          >
            {tenantOptions?.map((el: any) => (
              <Select.Option key={el.id} value={el.id}>
                {el.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          {...firstColumnLayout}
          label='机构名称'
          name='tenantId'
          {...required}
        >
          <Input autoComplete='off' disabled />
        </Form.Item>
        <Form.Item {...firstColumnLayout} label='合作平台' name='platformId'>
          <Input autoComplete='off' disabled />
        </Form.Item>
        <Form.Item
          {...firstColumnLayout}
          label='签约状态'
          name='signedType'
          {...required}
        >
          <Radio.Group>
            <Radio value={1}>已签约</Radio>
            <Radio value={0}>未签约</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item {...firstColumnLayout} label='Tenant' name='tenant'>
          <Input autoComplete='off' />
        </Form.Item>{' '}
        <Form.Item
          {...firstColumnLayout}
          label='医院编号'
          name='hospitalNumber'
          {...required}
          getValueFromEvent={stringTrim}
        >
          <Input autoComplete='off' />
        </Form.Item>{' '}
        <Form.Item
          {...firstColumnLayout}
          getValueFromEvent={stringTrim}
          label='药企机构代码'
          name='organCode'
          rules={[
            {
              required: true,
            },
            {
              pattern: new RegExp(/^[0-9]\d*$/, 'g'),
              message: '请输入数字',
            },
          ]}
        >
          <Input autoComplete='off' />
        </Form.Item>
        <Form.Item {...firstColumnLayout} label='账号' name='account'>
          <Input autoComplete='off' />
        </Form.Item>
        <Form.Item {...firstColumnLayout} label='密码' name='password'>
          <Input autoComplete='off' />
        </Form.Item>
        <Form.Item {...firstColumnLayout} label='接口地址' name='apiUrl'>
          <Input autoComplete='off' />
        </Form.Item>
        <Form.Item {...firstColumnLayout} label='接口token' name='apiToken'>
          <Input autoComplete='off' />
        </Form.Item>
        <Form.Item
          {...firstColumnLayout}
          label='代煎类别'
          name='decoctionType'
          {...required}
        >
          <Select
            mode='multiple'
            placeholder='请选择代煎类别'
            onChange={(e) => {
              const options: any = []
              const machiningType: any = []
              if (form.getFieldValue('decoctionType')?.length === 0) {
                form.setFieldsValue({
                  machiningType: [],
                  machiningTypeDefault: undefined,
                })
                setSelectMachiningType([])
                setMachiningTypeDisable(true)
              } else {
                setMachiningTypeDisable(false)
                form.getFieldValue('decoctionType')?.forEach((v: any) => {
                  category?.forEach((el: any) => {
                    if (v === el.typeVal) {
                      options.push(...el.outPotionDictList)
                    }
                  })
                })
                if (form.getFieldValue('machiningType')?.length !== 0) {
                  options?.forEach((el: any) => {
                    form.getFieldValue('machiningType')?.forEach((v: any) => {
                      if (el.typeVal === v) {
                        machiningType.push(v)
                      }
                    })
                  })
                }
                const matched = options?.filter((el: any) =>
                  machiningType?.includes(el.typeVal)
                )
                setSelectMachiningType(matched)
                form.setFieldsValue({
                  machiningType: machiningType,
                  machiningTypeDefault: findMachiningTypeDefault(
                    form.getFieldValue('machiningTypeDefault'),
                    matched
                  ),
                })
                setType(options)
              }
            }}
            onFocus={() => {
              dispatch(getAddEditType({ tenantId, id: supplierId }))
                .then(unwrapResult)
                .then((res: any) => {
                  setCategory(res)
                })
            }}
            disabled={decoctionTypeDisable}
          >
            {category?.map((c: any) => (
              <Select.Option key={c.id} value={c.typeVal}>
                {c.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          {...firstColumnLayout}
          label='加工方式'
          name='machiningType'
          {...required}
        >
          <Select
            mode='multiple'
            placeholder='请选择加工方式'
            disabled={machiningTypeDisable}
            onChange={(e: any) => {
              const data = type?.filter((v: any) => e?.includes(v?.typeVal))
              setSelectMachiningType(data)
              // 原默认加工方式不在新的加工方式里时清空，视为未选择
              form.setFieldsValue({
                machiningTypeDefault: findMachiningTypeDefault(
                  form.getFieldValue('machiningTypeDefault'),
                  data
                ),
              })
            }}
            onFocus={() => {
              dispatch(getAddEditType({ tenantId, id: supplierId }))
                .then(unwrapResult)
                .then((res: any) => {
                  setCategory(res)
                })
            }}
          >
            {type?.map((l: any) => (
              <Select.Option key={l.id} value={l.typeVal}>
                {l.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          {...firstColumnLayout}
          label='默认加工方式'
          name='machiningTypeDefault'
          {...required}
        >
          <Radio.Group>
            {selectMachiningType?.map((v: any) => {
              return (
                <>
                  <Radio value={v?.typeVal}>{v?.name}</Radio>
                </>
              )
            })}
          </Radio.Group>
        </Form.Item>
        <Form.Item
          {...firstColumnLayout}
          label='收货位置'
          name='receivingType'
          {...required}
        >
          <Select mode='multiple' placeholder='请选择收货位置'>
            {options?.map((c) => (
              <Select.Option key={c.value} value={c.value}>
                {c.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        {/*<Form.Item*/}
        {/*  {...firstColumnLayout}*/}
        {/*  label=''*/}
        {/*  name='specifications'*/}
        {/*>*/}
        {/*  <Input autoComplete='off' />*/}
        {/*</Form.Item>*/}
        <Form.Item label='处方剂型' {...firstColumnLayout}>
          <Row gutter={8}>
            <Col span={8}>
              <Form.Item name='recipeNormalFrequency' noStyle>
                <Select placeholder='请选择' allowClear>
                  {RecipeNormalFrequencyCategories?.map((v) => {
                    return (
                        <Select.Option value={v} key={v}>
                          {RecipeNormalFrequencyName(v)}
                        </Select.Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name='recipeNormalUsemethod' noStyle>
                <Select placeholder='请选择' allowClear>
                  {RecipeNormalUsemethodCategories?.map((v) => {
                    return (
                        <Select.Option value={v} key={v}>
                          {RecipeNormalUsemethodName(v)}
                        </Select.Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name='recipeNormalDose' noStyle>
                <Select placeholder='请选择' allowClear>
                  {RecipeNormalDoseCategories?.map((v) => {
                    return (
                        <Select.Option value={v} key={v}>
                          {RecipeNormalDoseTypeName(v)}
                        </Select.Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item {...firstColumnLayout} label='备注' name='remark'>
          <Input autoComplete='off' />
        </Form.Item>{' '}
        <Form.Item
          {...firstColumnLayout}
          label='是否默认选中'
          name='defaultSelected'
        >
          <Radio.Group>
            <Radio value={1}>是</Radio>
            <Radio value={0}>否</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Modal>
  )
}
